import React, {useMemo} from 'react';
import * as css from './WhatsAppPreview.css';
import {getTs,  tsToDate} from '../../../../library/dates';
import {useSelector} from 'react-redux';
import {useVariables} from '../../../../assets/objects/Variables';
import {useTranslation} from 'react-i18next';
import sanitizeHtml from '../../../../library/sanitizeHtml';
import LinkIcon from './linkIcon/LinkIcon';
import {IS_NEW_TEMPLATE} from '../../../../config/config';
import {useBrandingParams} from '../../../../hooks/useBrandingParams';
import {toCamelCase} from '../../../../functions/camelSnakeCaseConversion';
import {convertToHtml, serializeTemplateStructure} from '../../../../component/whatsAppTemplateEditor/utils/formatUtils';

function WhatsAppPreview({brandingPreview}) {
    const {messageType} = useBrandingParams();
    const {defaultVariables} = useVariables();
    const {t} = useTranslation('variables');
    const {whatsappContent, currentLang} = useSelector(s => ({
        currentLang: s.branding.currentLang,
        whatsappContent: s.branding.data?.[s.branding.currentLang]?.[messageType]?.['whatsappContent'] || '',
    }));
    const {isGivechak, isWhatsAppTemplate} = useSelector(s => ({
        isWhatsAppTemplate: IS_NEW_TEMPLATE(Number(s.event.eid)),
        isGivechak: s.event.type === 'givechak'
    }));
    
    const messageContent = useMemo(() => {
        return serializeTemplateStructure(whatsappContent);
    }, [whatsappContent]);

    const whatsappButtons = useMemo(() => {
        if(!whatsappContent || !Array.isArray(whatsappContent)) return [];
        return whatsappContent.filter(item => item.type === 'button');
    }, [whatsappContent]);

    const messageHtml = convertToHtml(messageContent, defaultVariables, t);

    return (   
        <css.wrapper data-cy={'whatsAppPreview'}>
            <css.title> 
                <css.profile />
                {brandingPreview||'Tickchak'}    
            </css.title>
            <css.messageContainer>
                <css.text time={tsToDate(getTs(), null, null, 'HH:mm')} dangerouslySetInnerHTML={sanitizeHtml(messageHtml)} />
                {isWhatsAppTemplate && !isGivechak && <css.buttonContainer>
                    {whatsappButtons.map((button, index) => (
                        <css.linkButton key={index}>
                            {t(toCamelCase((button.value).replace(/[[\]]/g, '')), {lng: currentLang})}
                            <LinkIcon />
                        </css.linkButton>
                    ))}
                </css.buttonContainer>}
            </css.messageContainer>
        </css.wrapper>
    );
}

export default WhatsAppPreview;
